import { useSearchParams } from "react-router-dom";
import { Sparkle, Camera, Microphone } from "@phosphor-icons/react";
import { AdminShell } from "@/components/Layout";
import AdminPhotoCommand from "@/pages/AdminPhotoCommand";
import AdminVoiceToJob from "@/pages/AdminVoiceToJob";

/**
 * AskRadar — unified hub for the two AI capture flows. Photo Command and
 * Voice-to-Job live as inner sections here so users don't have to hunt for
 * two sidebar rows. The child pages accept an `embedded` prop that skips
 * their own AdminShell wrapper.
 */
export default function AskRadar() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "voice" ? "voice" : "photo";
  const setTab = (t) => setParams({ tab: t });

  return (
    <AdminShell>
      <div className="max-w-5xl mx-auto px-4 pt-4">
        <div className="flex items-center gap-3">
          <Sparkle weight="fill" size={30} className="text-fuchsia-600"/>
          <h1 className="font-display font-black text-3xl sm:text-4xl uppercase tracking-tight">Ask Radar</h1>
        </div>
        <p className="mt-1 text-sm text-slate-600">
          Two ways to feed Radar: scan a whiteboard photo, or dictate on the fly. Radar routes into the right place — jobs, projects, or ClosureRadar™.
        </p>
        <div className="mt-4 inline-flex border-2 border-[#0f172a] bg-white" data-testid="ask-radar-tabs">
          <button onClick={() => setTab("photo")} data-testid="ask-radar-tab-photo"
            className={`px-4 h-11 text-[10px] font-black uppercase tracking-widest inline-flex items-center gap-1.5 ${tab === "photo" ? "bg-violet-600 text-white" : "hover:bg-slate-50 text-slate-700"}`}>
            <Camera weight="bold" size={14}/> Photo Command
          </button>
          <button onClick={() => setTab("voice")} data-testid="ask-radar-tab-voice"
            className={`px-4 h-11 text-[10px] font-black uppercase tracking-widest inline-flex items-center gap-1.5 ${tab === "voice" ? "bg-fuchsia-600 text-white" : "hover:bg-slate-50 text-slate-700"}`}>
            <Microphone weight="bold" size={14}/> Voice-to-Job
          </button>
        </div>
      </div>
      <div data-testid="ask-radar-content">
        {tab === "photo" ? <AdminPhotoCommand embedded/> : <AdminVoiceToJob embedded/>}
      </div>
    </AdminShell>
  );
}
